module.exports = __webpack_public_path__ + "img/907817395.7ab14745.jpg";